webpackJsonp([170786371021445],{

/***/ 777:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. <br />\nI will answer to your message as soon as possible.</p>","frontmatter":{"title":"Success"}},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-920e01c2046686f6525e.js